// @flow
import client from '../../client'
import format from '../../utils/format'

// API Endpoinds
export const GET_PROVIDER_ENDPOINT = '/data-entry/providers/{0}/'

/**
 * Returns an updated provider
 * @param {Object} data Data
 * @param {string} data.id Provider ID
 * @param {Object} data.provider Provider data
 * @return {Promise|Error} A resolved Promise with a provider or Rejected with an Error
 */
export const update = (data: {
  id: string,
  provider: {
    id: string,
    holydays: Array<Object>,
    contact_info: string,
    name: string,
    description: string,
    currency: string,
    support_hours: string,
    website: string,
    logo: string,
    military_time_format: string,
    advance_notification_booking: string,
    advance_notification_cancellation: string,
    has_holiday_service: string,
    holiday_surcharge_percentage: string,
    email_lang: string,
    results_unverified: string,
  },
}): Promise<any> => {
  const endpoint = format(GET_PROVIDER_ENDPOINT, data.id)

  return client.put(endpoint, { body: data.provider })
}

export default update
